import { get } from 'http';

export const RoleJobTitleVariables = {
  getAllJobTitle: (params: any) => {
    const { page, page_size, input } = params;

    return {
      ...(page && { skip: (page - 1) * page_size }),
      ...(page_size && { take: page_size }),
      input: {
        id: {
          equals: input?.id,
        },
        jobName: {
          contains: input?.jobName,
        },
        trole: {
          name: {
            contains: input?.role,
          },
        },
      },
    };
  },
  updateJobTitle: (data: any) => {
    return {
      input: {
        id: data?.id,
        roleId: data?.roleId,
      },
    };
  },
  getJobTitleComboBoxVariable: () => {
    return {
      input: {},
    };
  },
};
